<ion-content color="primary">
  <div class="content">
    <img *ngIf="brand !== 'erdman'" [src]="loaderImg" alt="Loader" />
    <div *ngIf="brand === 'erdman'" class="loadingio-spinner-double-ring-freyurszfti">
      <div class="ldio-2osr0q8yzqx">
        <div></div>
        <div></div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    </div>
    <p>GATHERING DATA</p>
  </div>
</ion-content>

